/**
 * Normalises a `patientEnteredMedicationsFreeText` value into an array of entries.
 * The control can legitimately hold either a raw comma/newline string (e.g. from the
 * legacy intake path) or an array of entries (strings or Drug objects). Splitting a
 * string here — rather than discarding it — keeps previously staged medications alive
 * until the MedicationReconciler folds them into `medications`.
 */
export function splitMedicationFreeText(value: any): any[] {
  if (typeof value === 'string') {
    return value
      .split(/[\n,]/)
      .map(entry => entry.trim())
      .filter(entry => entry.length > 0);
  }
  return Array.isArray(value) ? value : [];
}
